import {IMuWidget} from "./IMuWidget";
import {sleepPromise} from "./Utils";


export class Htmlarea extends IMuWidget {
	public disabled : boolean = false;

	public async setDisabled(disabled: boolean) {
		this.muVisible(disabled, [ '!content', 'roContent' ]);
		await this.editorPromise;
	}

	protected editor: any;

	public delayedInit: boolean = false;

	public uploadUrl: string|null = null;

	// @ts-ignore
	protected editorPromise: Promise<any>;

	private editorIsInitialized: boolean = false;

	beforeIndex() {
		this.muRegisterEvent('change');
		this.container.innerHTML += `
			<div mu-id="content" class="html-area--content"></div>
			<div mu-id="roContent"  class="html-area--content html-area--content--readonly"></div>`;
		const heValue = this.container.querySelector('input'); // 'input'
		heValue?.setAttribute('mu-id', 'value');
		// heValue.style.display = "none";
		this.container.classList.add('html-area');
	}

	afterIndex() {
		if (this.delayedInit)
			this.muParent?.muOnAfterIndex.push(() => this.initCKEditor());
		else
			this.initCKEditor();
		this.setDisabled(false);
	}

	initCKEditor() {
		if (this.ui.value) this.ui.content.innerHTML = this.ui.value.value;
		if (this.ui.placeholder) {
			this.ui.placeholder.innerHTML = '';
		}
		if (!this.disabled)
		{
			const updateContent = (html : string) => {
				if (this.ui.value) this.ui.value.value = html;
			}
			// @ts-ignore
			const _conf = conf;
			// @ts-ignore
			this.editorPromise = InlineEditor
				.create(this.ui.content, {
					licenseKey: '',
					// plugins: [ 'SimpleUploadAdapter' ],
					simpleUpload: {
						// The URL that the images are uploaded to.
						uploadUrl: this.uploadUrl ?? _conf.urlUploadPath
					},
					toolbar: {
						items: [
							"heading", "|", "bold", "italic", 'strikethrough', 'underline', "link", "bulletedList", "numberedList",
							"|", "outdent", "indent",
							"|", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "code", "codeBlock", "horizontalLine",
							"|", "fontColor", "highlight", "fontSize", "|", "undo", "redo"
						]
					},

					resize_minHeight: 200
				} )
				.then( editor => {
					editor.model.document.on( 'change:data', ( evt, data ) => {
						const content = editor.getData();
						updateContent(content);
						this.muDispatchEvent("change", content);
					});
					editor.ui.focusTracker.on( 'change:isFocused', ( evt, name, isFocused ) => updateContent(editor.getData()));
					this.editor = editor;
				} )
				.catch( error => {
					console.error( 'Oops, something went wrong!' );
					console.error( 'Please, report the following error on https://github.com/ckeditor/ckeditor5/issues with the build id and the error stack trace:' );
					console.warn( 'Build id: w19cfme1zfn4-77un9p80tfp5' );
					console.error( error );
				} );
		}
		this.editorPromise.then(() => this.editorIsInitialized = true)
	}

	async muBindData(srcData: any) {
		// const doBindData = () => this.editor.setData(srcData);
		// if (this.editor) doBindData();
		// else this.editorPromise.then(() => doBindData()) ;
		await this.editorPromise;
		await sleepPromise(10);
		this.editor.setData(srcData || "");
		this.ui.roContent.innerHTML = srcData;
	}

	muFetchData(): any {
		return this.editor?.getData();
	}

	focus() {
		this.ui.content.focus();
		if (this.editorPromise != null) {
			this.editorPromise.then(() => this.editor.focus());

		}
	}

	async waitForInit(): Promise<void> {
		return this.editorPromise;
	}

	public isInitialized(): boolean
	{
		return this.editorIsInitialized;
	}
}